<template>
  <base-button class="btn-secondary" text="利用再開" />
</template>
<script>
import BaseButton from "@/views/atoms/BaseButton";

export default {
  name: 'RestoreButton',
  components: {
    BaseButton
  },
}
</script>
